import { mapGetters } from 'vuex';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import brokerageInfo from '@/common/store/glb/data.brokerage';

export default {
    name: 'agentBar',
    inject: ['$eventBus'],
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        currentBrokerage() {
            if (this.glb.geo.hardcode) {
                return null;
            }
            const key = `${this.glb.geo.cityCode}-${this.glb.geo.stateCode}`;
            if (brokerageInfo[key]) {
                return brokerageInfo[key];
            }
            return null;
        },
        isAgentCityPage() {
            return this.glb.pageType === 'vagentsearch_city';
        },
    },
    components: {
        mvtShifter,
    },
};
